// Conversione unità PURA per il food cost (massa kg↔g, volume l↔ml) + identità.
// Ritorna null quando la conversione NON è derivabile da sola (es. pz↔kg): in
// quei casi il costo riga resta indisponibile (mai inventato). Copia allineata a
// apps/mobile/src/lib/uom.ts:convertQty (client) — shared non può importare l'app.
type CanonicalComparableUom =
  | 'pz'
  | 'kg'
  | 'g'
  | 'l'
  | 'ml'
  | 'conf'
  | 'ct'
  | 'cassa'
  | 'bottiglia';

// Mirror intenzionale di functions/_shared/uom.ts. Per le unità sconosciute
// restituiamo il testo normalizzato, non il fallback `pz`: una conversione da
// una custom UOM deve quindi essere esplicita.
const UOM_ALIASES: Readonly<Record<string, CanonicalComparableUom>> = {
  pz: 'pz', 'pz.': 'pz', pzi: 'pz',
  nr: 'pz', 'nr.': 'pz', n: 'pz', 'n.': 'pz', num: 'pz', numero: 'pz',
  pezzo: 'pz', pezzi: 'pz',
  cad: 'pz', 'cad.': 'pz', cadauno: 'pz',
  ud: 'pz', 'u.d.': 'pz', unita: 'pz', 'unità': 'pz',
  ea: 'pz', each: 'pz',
  kg: 'kg', 'kg.': 'kg', chilo: 'kg', chili: 'kg',
  chilogrammo: 'kg', chilogrammi: 'kg', kilo: 'kg', kilogrammi: 'kg',
  g: 'g', 'g.': 'g', gr: 'g', 'gr.': 'g', grammi: 'g', grammo: 'g',
  l: 'l', 'l.': 'l', lt: 'l', 'lt.': 'l', litro: 'l', litri: 'l',
  ml: 'ml', 'ml.': 'ml', millilitri: 'ml', millilitro: 'ml',
  conf: 'conf', 'conf.': 'conf', cf: 'conf', 'cf.': 'conf',
  confezione: 'conf', confezioni: 'conf',
  ct: 'ct', 'ct.': 'ct', cart: 'ct', 'cart.': 'ct',
  cartone: 'ct', cartoni: 'ct',
  cs: 'cassa', 'cs.': 'cassa', cassa: 'cassa', casse: 'cassa',
  bot: 'bottiglia', 'bot.': 'bottiglia', bt: 'bottiglia',
  'bt.': 'bottiglia', bottiglia: 'bottiglia', bottiglie: 'bottiglia',
};

export function normalizeComparableUom(
  u: string | null | undefined,
): string {
  const normalized = (u ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  if (!normalized) return '';
  return UOM_ALIASES[normalized.replace(/\s+/g, '')] ?? normalized;
}

export function convertQty(qty: number, from: string, to: string): number | null {
  const f = normalizeComparableUom(from);
  const t = normalizeComparableUom(to);
  if (f === t) return qty;
  if (f === 'g' && t === 'kg') return qty / 1000;
  if (f === 'kg' && t === 'g') return qty * 1000;
  if (f === 'ml' && t === 'l') return qty / 1000;
  if (f === 'l' && t === 'ml') return qty * 1000;
  return null;
}
